import { render, staticRenderFns } from "./preset-book-edit.component.vue?vue&type=template&id=a56876c6&scoped=true"
import script from "./preset-book-edit.component.vue?vue&type=script&lang=ts"
export * from "./preset-book-edit.component.vue?vue&type=script&lang=ts"
import style0 from "./preset-book-edit.component.vue?vue&type=style&index=0&id=a56876c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56876c6",
  null
  
)

export default component.exports